var _defs, _rect, _polygon, _path, _path2, _path3, _path4, _path5, _polygon2, _path6, _path7, _path8, _path9, _path10, _polygon3, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavedPayeeReviewDeselected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1317 79.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-3{fill:#fff;}.cls-1{fill-opacity:0;}.cls-2{fill:#e06b30;}.cls-4{fill:#8e8c99;}.cls-5{isolation:isolate;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    y: 0.05,
    width: 1317,
    height: 79
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "245.67 79.07 0.42 79.07 27.22 39.53 0.42 0 245.67 0 272.48 39.53 245.67 79.07"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M85.05,49.84A9.8,9.8,0,0,1,81.29,58q-3.75,3-10.37,3A24.8,24.8,0,0,1,60.1,59V53a29.39,29.39,0,0,0,5.67,2,23.91,23.91,0,0,0,5.58.72c2.52,0,4.39-.48,5.58-1.44a4.71,4.71,0,0,0,1.8-3.86,4.84,4.84,0,0,0-1.65-3.71c-1.1-1-3.38-2.21-6.82-3.6a18.56,18.56,0,0,1-7.52-5,10.47,10.47,0,0,1-2.18-6.66A9.29,9.29,0,0,1,64,23.69q3.47-2.79,9.3-2.79a27.19,27.19,0,0,1,11.16,2.45l-2,5.19a24.39,24.39,0,0,0-9.28-2.18,7.11,7.11,0,0,0-4.69,1.35,4.44,4.44,0,0,0-1.6,3.55,5.12,5.12,0,0,0,.64,2.6,6.41,6.41,0,0,0,2.11,2,35.54,35.54,0,0,0,5.28,2.53,29.37,29.37,0,0,1,6.29,3.33,10.09,10.09,0,0,1,2.93,3.49A10.53,10.53,0,0,1,85.05,49.84Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M106.05,60.42H99.68V26.92H88.22V21.46h29.29v5.46H106.05Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M145.52,60.42h-22v-39h22V26.8H129.85V37.45h14.68v5.33H129.85V55.05h15.67Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.74,33.24q0,6.09-4,9.35t-11.38,3.25h-4.05V60.42h-6.37v-39h11.22q7.31,0,10.94,3T179.74,33.24Zm-19.43,7.24h3.38c3.27,0,5.67-.56,7.2-1.7a6.18,6.18,0,0,0,2.29-5.33,6,6,0,0,0-2.05-5c-1.37-1.1-3.51-1.65-6.4-1.65h-4.42Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M217.34,60.42h-6.26V35.26q0-4.5.21-7.14c-.41.42-.91.9-1.5,1.41s-2.59,2.15-6,4.9l-3.14-4,11.46-9h5.22Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "507 79.07 261.75 79.07 288.56 39.53 261.75 0 507 0 533.81 39.53 507 79.07"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M340.54,49.84A9.8,9.8,0,0,1,336.78,58q-3.75,3-10.36,3a24.66,24.66,0,0,1-10.82-2V53a29.07,29.07,0,0,0,5.66,2,23.91,23.91,0,0,0,5.58.72c2.53,0,4.4-.48,5.59-1.44a4.71,4.71,0,0,0,1.8-3.86,4.83,4.83,0,0,0-1.66-3.71q-1.65-1.51-6.82-3.6-5.33-2.16-7.51-4.93a10.4,10.4,0,0,1-2.19-6.66,9.33,9.33,0,0,1,3.47-7.68c2.3-1.86,5.41-2.79,9.3-2.79A27.21,27.21,0,0,1,340,23.35l-2,5.19a24.38,24.38,0,0,0-9.27-2.18A7.09,7.09,0,0,0,324,27.71a4.38,4.38,0,0,0-1.6,3.55,4.92,4.92,0,0,0,.64,2.6,6.47,6.47,0,0,0,2.1,2,35.54,35.54,0,0,0,5.28,2.53,28.28,28.28,0,0,1,6.29,3.33,9.79,9.79,0,0,1,2.93,3.49A10.55,10.55,0,0,1,340.54,49.84Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M361.54,60.42h-6.37V26.92H343.71V21.46H373v5.46H361.54Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M401,60.42H379v-39h22V26.8H385.34V37.45H400v5.33H385.34V55.05H401Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M435.23,33.24q0,6.09-4,9.35t-11.38,3.25H415.8V60.42h-6.37v-39h11.22q7.31,0,10.94,3T435.23,33.24ZM415.8,40.48h3.39c3.27,0,5.67-.56,7.19-1.7a6.22,6.22,0,0,0,2.3-5.33,6,6,0,0,0-2.06-5q-2.06-1.65-6.39-1.65H415.8Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M480.86,60.42H454.45V55.68l10-10.11a86,86,0,0,0,5.91-6.46,15.54,15.54,0,0,0,2.11-3.58,9.66,9.66,0,0,0,.67-3.6,5.5,5.5,0,0,0-1.58-4.16,6.08,6.08,0,0,0-4.39-1.52,11.7,11.7,0,0,0-4.33.83,20.7,20.7,0,0,0-4.84,3L454.62,26A22.25,22.25,0,0,1,461,22.1,18.62,18.62,0,0,1,467.52,21a12.86,12.86,0,0,1,8.72,2.83,9.64,9.64,0,0,1,3.28,7.64,13.38,13.38,0,0,1-.95,5,20.63,20.63,0,0,1-2.9,4.89,66.48,66.48,0,0,1-6.54,6.78l-6.77,6.56v.26h18.5Z"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "768.34 79.07 523.09 79.07 549.89 39.53 523.09 0 768.34 0 795.14 39.53 768.34 79.07"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M573.07,44.29v15.6h-6.39v-39h11c5,0,8.77.95,11.19,2.83s3.63,4.74,3.63,8.55q0,7.29-7.59,10.39l11,17.28h-7.26l-9.35-15.6Zm0-5.29h4.43c3,0,5.13-.55,6.47-1.65a6,6,0,0,0,2-4.92,5.29,5.29,0,0,0-2.16-4.75q-2.17-1.44-6.52-1.44h-4.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M623.74,59.89H601.65v-39h22.09v5.4H608V36.87h14.72v5.34H608V54.47h15.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M654.42,20.84h6.63L647.37,59.89h-6.73L627,20.84h6.57l8.15,24.28c.42,1.16.88,2.65,1.36,4.47s.79,3.19.93,4.08c.23-1.36.59-2.92,1.07-4.7s.87-3.1,1.18-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M666.2,59.89v-39h6.39V59.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M705,59.89H682.9v-39H705v5.4h-15.7V36.87H704v5.34H689.28V54.47H705Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M749.45,59.89h-6.94L735.89,36.6c-.29-1-.64-2.48-1.07-4.39s-.69-3.25-.78-4c-.17,1.14-.46,2.62-.86,4.44s-.74,3.17-1,4.06l-6.46,23.18h-6.94l-5-19.55-5.13-19.5h6.52l5.58,22.76q1.3,5.48,1.87,9.67c.19-1.52.49-3.21.88-5.08s.75-3.38,1.07-4.54l6.36-22.81h6.33l6.51,22.92a87.7,87.7,0,0,1,2,9.51,70.91,70.91,0,0,1,1.92-9.73l5.56-22.7h6.46Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedPayeeReviewDeselected);
export default __webpack_public_path__ + "static/media/saved-payee-review-deselected.5c396e9caac4ac18335f3dc0ae1097a8.svg";
export { ForwardRef as ReactComponent };